// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* prevent content from being hidden behind the fixed bottom nav 
body {
  padding-bottom: 80px; /* reserve space for bottom nav 
}*/
/*
.main-container {
  padding: 20px;
}
*/

/* This is needed to get the RGB values of bootstrap theme colors */
body {
  --bs-primary-rgb: 13,110,253;
  --bs-success-rgb: 25,135,84;
  --bs-warning-rgb: 255,193,7;
  --bs-info-rgb: 13,202,240;
}

.glassy-card {
  background-color: rgba(var(--bs-primary-rgb), 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgba(var(--card-bg-color-rgb), 0.7) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;;CAIC;;AAED,mEAAmE;AACnE;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8DAA8D;EAC9D,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gEAAgE;AAClE","sourcesContent":["/* prevent content from being hidden behind the fixed bottom nav \nbody {\n  padding-bottom: 80px; /* reserve space for bottom nav \n}*/\n/*\n.main-container {\n  padding: 20px;\n}\n*/\n\n/* This is needed to get the RGB values of bootstrap theme colors */\nbody {\n  --bs-primary-rgb: 13,110,253;\n  --bs-success-rgb: 25,135,84;\n  --bs-warning-rgb: 255,193,7;\n  --bs-info-rgb: 13,202,240;\n}\n\n.glassy-card {\n  background-color: rgba(var(--bs-primary-rgb), 0.15) !important;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: rgba(var(--card-bg-color-rgb), 0.7) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
